module.exports = __webpack_public_path__ + "img/banner-1@2x-min.00e142fe.png";